export default __webpack_public_path__ + "static/media/ingredientManagementt.d0803393.png";